var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSession(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 5.75V13.625H14.75V5.75H1.25ZM0.6875 4.625H15.3125C15.4617 4.625 15.6048 4.68426 15.7102 4.78975C15.8157 4.89524 15.875 5.03832 15.875 5.1875V14.1875C15.875 14.3367 15.8157 14.4798 15.7102 14.5852C15.6048 14.6907 15.4617 14.75 15.3125 14.75H0.6875C0.538316 14.75 0.395242 14.6907 0.289752 14.5852C0.184263 14.4798 0.125 14.3367 0.125 14.1875V5.1875C0.125 5.03832 0.184263 4.89524 0.289752 4.78975C0.395242 4.68426 0.538316 4.625 0.6875 4.625ZM1.8125 2.375H14.1875V3.5H1.8125V2.375ZM3.5 0.125H12.5V1.25H3.5V0.125Z",
    fill: "#0D99FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSession);
export default __webpack_public_path__ + "static/media/icon-session.0e1e749f.svg";
export { ForwardRef as ReactComponent };